const {REACT_APP_URL_PREFIX} = process.env

const systemManager = {
    id: 2,
    name: 'System Manager',
    links: [
        {
            title: 'Пациент',
            routeOrigin: 'patients',
            key: '1dceывws',
            route: REACT_APP_URL_PREFIX + '/patients/allPatients'
        },
        {
            title: 'Доктор',
            routeOrigin: 'doctors',
            key: '1deczwssыв',
            route: REACT_APP_URL_PREFIX + '/doctors/',
            dropDownRouteList: [
                {
                    title: 'Список докторов',
                    key: '1deыcвывws',
                    route: REACT_APP_URL_PREFIX + '/doctors/list'
                },              {
                    title: 'Результаты тестирования',
                    key: '479812370409d',
                    route: REACT_APP_URL_PREFIX + '/doctors/test-results'
                },    {
                    title: 'Снимки',
                    key: '479812370409d',
                    route: REACT_APP_URL_PREFIX + '/doctors/images'
                },
                {
                    title: 'Несовпадение диагнозов',
                    key: '1dedsывasdwss',
                    route: REACT_APP_URL_PREFIX + '/doctors/diagnoses-mismatch'
                }

            ],
        },
        {
            title: 'Контрагенты',
            routeOrigin: 'counterAgents',
            key: '1deczwsыв',
            route: REACT_APP_URL_PREFIX + '/counterAgents/MedCenterList',
            dropDownRouteList: [
                {
                    title: 'Удостов. Центры',
                    key: '1deыcвывws',
                    route: REACT_APP_URL_PREFIX + '/counterAgents/verificationCenters'
                },
                {title: 'Мед. Центры', key: '1deыzвws', route: REACT_APP_URL_PREFIX + '/counterAgents/medCenters'},
                {title: 'Организации', key: '1dedszывws', route: REACT_APP_URL_PREFIX + '/counterAgents/organizations'},
                {title: 'Все', key: '1zdeывsws', route: REACT_APP_URL_PREFIX + '/counterAgents/allOrganizations'},
                {title: 'Добавить платеж', key: '1ываыыыdeывws', route: REACT_APP_URL_PREFIX + '/counterAgents/addPayment'},
            ],
        },
        {
            title: 'Календарь', routeOrigin: 'calendar', key: '1dedвws', route: REACT_APP_URL_PREFIX + '/calendar',
            dropDownRouteList: [
                {title: "Каленадрь", key: '23bdwsji9', route: REACT_APP_URL_PREFIX + '/calendar'},
                {
                    title: 'История обследований',
                    key: '23ddjqi9',
                    route: REACT_APP_URL_PREFIX + '/calendar/cabinetSurveys'
                },
                {title: 'История выездов', key: '23bdxji9', route: REACT_APP_URL_PREFIX + '/calendar/carSurveys'},
                {title: 'Выезды сегодня', key: '2e5str3ddji9', route: REACT_APP_URL_PREFIX + '/calendar/carSurveysToday'},
            ]
        },
        {
            title: 'Активность',
            routeOrigin: 'activities',
            key: '1dasdedвws',
            route: REACT_APP_URL_PREFIX + '/activities',
            dropDownRouteList: [
                {title: 'Лаборанты', key: '23cbdsxji9', route: REACT_APP_URL_PREFIX + '/activities/roles'},
                {title: 'Редактирование', key: '23cbsdфsxji9', route: REACT_APP_URL_PREFIX + '/activities/editing'},
                {title: 'Аналитика РК', key: '23cbsdsxыji9', route: REACT_APP_URL_PREFIX + '/activities/analytic/places'},
                {title: 'Аналитика доктора', key: '23cbsdsxыji9', route: REACT_APP_URL_PREFIX + '/activities/analytic/doctor'},
            ]
        }, {
            title: 'Уведомления',
            routeOrigin: 'notifications',
            key: '1dыфasdedвws',
            route: REACT_APP_URL_PREFIX + '/notifications',
        },
    ]
}
const organization = {
    id: 3,
    name: 'organization',
    links: [
        {
            title: 'Пациенты',
            routeOrigin: 'patients',
            key: '1deывws',
            route: REACT_APP_URL_PREFIX + '/patients/allPatientList'
        },
        {
            title: 'Контрагенты',
            routeOrigin: 'counterAgents',
            key: '1deswsыв',
            route: REACT_APP_URL_PREFIX + '/counterAgents/orgHistory'
        },
        // {
        //     title: 'Бронирование',
        //     routeOrigin: 'booking',
        //     key: '1dessws',
        //     route: REACT_APP_URL_PREFIX + '/booking'
        // },
		// {
        //     title: 'Уведомления',
        //     routeOrigin: 'notifications',
        //     key: '1desswывs',
        //     route: REACT_APP_URL_PREFIX + '/notifications'
        // },
    ]
}
const medCenter = {
    id: 4,
    name: 'MedCenter',
    links: [
        {
            title: 'Пациенты',
            routeOrigin: 'patients',
            key: '1deывws',
            route: REACT_APP_URL_PREFIX + '/patients/allPatientList'
        },
        {
            title: 'Контрагенты',
            routeOrigin: 'counterAgents',
            key: '1deswsыв',
            route: REACT_APP_URL_PREFIX + '/counterAgents/orgList'
        },
        // {
        //     title: 'Бронирование',
        //     routeOrigin: 'booking',
        //     key: '1desws',
        //     route: REACT_APP_URL_PREFIX + '/booking'
        // },
		// {
		// 	title: 'Уведомления',
		// 	routeOrigin: 'notifications',
		// 	key: '1desswывs',
		// 	route: REACT_APP_URL_PREFIX + '/notifications'
		// },
    ]
}
const verificationCenter = {
    id: 5,
    name: 'organization',
    links: [
        {
            title: 'Пациент',
            routeOrigin: 'patients',
            key: '1deывws',
            route: REACT_APP_URL_PREFIX + '/patients/allPatientList'
        },
        {
            title: 'Доктор',
            routeOrigin: 'doctors',
            key: '1dewsыasв',
            route: REACT_APP_URL_PREFIX + '/counterAgents/MedCenterList',
            dropDownRouteList: [
                {
                    title: 'Список докторов',
                    key: '1dgdfeыcвывws',
                    route: REACT_APP_URL_PREFIX + '/doctors/list'
                },              {
                    title: 'Несовпадение диагнозов',
                    key: '1dedsывasdwss',
                    route: REACT_APP_URL_PREFIX + '/doctors/diagnoses-mismatch'
                }
            ],
        },        {
            title: 'Контрагенты',
            routeOrigin: 'counterAgents',
            key: '1dewsыв',
            route: REACT_APP_URL_PREFIX + '/counterAgents/MedCenterList',
            dropDownRouteList: [
                {title: 'Мед. Центры', key: '1deывws', route: REACT_APP_URL_PREFIX + '/counterAgents/MedCenterList'},
                {
                    title: 'Организации',
                    key: '1dedsывws',
                    route: REACT_APP_URL_PREFIX + '/counterAgents/OrganizationList'
                },
                {title: 'Все', key: '1deывsws', route: REACT_APP_URL_PREFIX + '/counterAgents/allOrgList'},
            ],
        },
        {
            title: 'Календарь', routeOrigin: 'calendar', key: '1deвws', route: REACT_APP_URL_PREFIX + '/calendar',
            dropDownRouteList: [
                {title: "Каленадрь", key: '23bdji9', route: REACT_APP_URL_PREFIX + '/calendar'},
                {
                    title: 'История обследований',
                    key: '23ddji9',
                    route: REACT_APP_URL_PREFIX + '/calendar/cabinetSurveys'
                },
                {title: 'История выездов', key: '23bdji9', route: REACT_APP_URL_PREFIX + '/calendar/carSurveys'},
                {title: 'Выезды сегодня', key: '2e5tor3ddji9', route: REACT_APP_URL_PREFIX + '/calendar/carSurveysToday'},
            ]
        },
        {
            title: 'Активность',
            routeOrigin: 'activities',
            key: '1dasdedвws',
            route: REACT_APP_URL_PREFIX + '/activities',
            dropDownRouteList: [
                {title: 'Лаборанты', key: '23cbdsxji9', route: REACT_APP_URL_PREFIX + '/activities/roles'},
                {title: 'Аналитика РК', key: '23cbsdsxыji9', route: REACT_APP_URL_PREFIX + '/activities/analytic/places'},
                {title: 'Аналитика доктора', key: '23cbsdsxыji9', route: REACT_APP_URL_PREFIX + '/activities/analytic/doctor'},
            ]
        },
        //    {
        //     title: 'Уведомление',
        //     routeOrigin: 'notifications',
        //     key: '1deasdывws',
        //     route: REACT_APP_URL_PREFIX + '/notifications'
        // },
    ]
}
const patient = {
    id: 7,
    name: 'patient',
    links: [
        {
            title: 'Снимки пациента',
            routeOrigin: 'patient-page',
            key: '1ds',
            route: REACT_APP_URL_PREFIX + '/patient-page'
        },
        //{
        //    title: 'История платежей',
        //    routeOrigin: 'patient-payments',
        //    key: '2fds',
        //    route: REACT_APP_URL_PREFIX + '/patient-payments'
        //},
        //{
        //    title: 'Обращения',
        //    routeOrigin: '/notifications',
        //    key: '2fds',
        //    route: REACT_APP_URL_PREFIX + '/notifications'
        //}
    ]
}
const cabinetAssitant = {
    id: 9,
    name: 'Assistant',
    links: [
        {
            title: 'Пациент',
            routeOrigin: 'patients',
            key: '1deывws',
            route: REACT_APP_URL_PREFIX + '/patients/allPatients'
        },
        {
            title: 'Календарь', routeOrigin: 'calendar', key: '1deвws', route: REACT_APP_URL_PREFIX + '/',
            dropDownRouteList: [
                {
                    title: 'История обследований',
                    key: '23ddji9',
                    route: REACT_APP_URL_PREFIX + '/calendar/cabinetSurveys'
                },
            ]
        },
    ]
}
const carAssistant = {
    id: 10,
    name: 'Assistant',
    links: [
        {
            title: 'Пациент',
            routeOrigin: 'patients',
            key: '1deывws',
            route: REACT_APP_URL_PREFIX + '/patients/allPatients'
        },
        {
            title: 'Календарь', routeOrigin: 'calendar', key: '1deвws', route: REACT_APP_URL_PREFIX + '/',
            dropDownRouteList: [
                {title: 'История выездов', key: '23ddji9', route: REACT_APP_URL_PREFIX + '/calendar/carSurveys'},
                {title: 'Выезды сегодня', key: '2e5tr3ddji9', route: REACT_APP_URL_PREFIX + '/calendar/carSurveysToday'},
            ]
        },
    ]
}

export const model = [cabinetAssitant, patient, carAssistant, verificationCenter, medCenter, organization, systemManager]

